"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class FetchClassesSectionStatsBadRequest extends client_library_1.ExtendableError {
    constructor(reason) {
        super(`Could not fetch classes section stats: ${reason}`);
    }
}
exports.default = FetchClassesSectionStatsBadRequest;
//# sourceMappingURL=FetchClassesSectionStatsBadRequestError.js.map